import { action } from 'mobx'
import {
  ITelemetrySendRPC,
  ITelemetryEvent,
  ICommandContext,
} from '@prisma/studio-types'

import ModelStore from 'stores/model/ModelStore'

class TelemetryStore {
  @action
  send(event: Omit<ITelemetryEvent, 'commandContext'>) {
    // Omit<ITelemetryEvent, 'commandContext'> flattens the type, so invalid payloads become possible. Don't use `Omit` here

    window.transport.request<ITelemetrySendRPC>({
      channel: 'telemetry',
      action: 'send',
      payload: {
        data: {
          command: event.command as ITelemetryEvent['command'],
          commandDetails: JSON.stringify(
            event.commandDetails
          ) as ITelemetryEvent['commandDetails'],
          commandContext: JSON.stringify({
            model_count: ModelStore.size,
          } as ICommandContext),
        } as any,
      },
    })
  }
}

export default new TelemetryStore()
